(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["teetao-category-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  const names = {category:'tt_category',country:'tt_country',feature:'tt_feature',caffeine:'tt_caffeine',meaning:'tt_meaning',material:'tt_material',format:'tt_format',purpose:'tt_purpose'};
  const applyGiftPurpose = nav => {
    if (nav.dataset.baseCollection !== 'gift-card') return;
    const purpose = new URL(location.href).searchParams.get(names.purpose);
    if (!purpose || ![...nav.querySelectorAll('[data-tt-group="purpose"] [data-key]')].some(b => b.dataset.key === purpose)) return;
    const section = nav.closest('.shopify-section');
    const grid = section.querySelector('#ProductGridContainer');
    const countTemplate = nav.querySelector('[data-tt-gift-count-label]');
    if (!grid || !countTemplate) return;
    const cards = [...section.querySelectorAll('#product-grid > [data-tt-gift-purpose]')];
    cards.forEach(card => {
      const hidden = card.dataset.ttGiftPurpose.trim() !== purpose;
      if (card.hidden !== hidden) card.hidden = hidden;
    });
    const count = cards.filter(card => !card.hidden).length;
    const countLabels = JSON.parse(countTemplate.textContent);
    const countLabel = count === 1 ? countLabels.one : countLabels.other.replace('__count__',String(count));
    section.querySelectorAll('#ProductCount,#ProductCountDesktop,[data-tt-result-count]').forEach(e => {
      if (e.textContent !== countLabel) e.textContent = countLabel;
    });
    if (grid.hidden !== (count === 0)) grid.hidden = count === 0;
    const emptyNotice = section.querySelector('[data-tt-invalid-filter]');
    if (emptyNotice.hidden !== (count > 0)) emptyNotice.hidden = count > 0;
  };
  const init = nav => {
    if (nav.dataset.ttReady) {applyGiftPurpose(nav);return;}
    nav.dataset.ttReady = 'true';
    const section = nav.closest('.shopify-section');
    const summary = section.querySelector('[data-tt-active-filters]');
    const notice = section.querySelector('[data-tt-filter-notice]');
    const available = new Set(JSON.parse(nav.querySelector('[data-tt-available-tags]').textContent));
    const currentTags = new Set(JSON.parse(nav.querySelector('[data-tt-current-tags]').textContent));
    const buttons = [...nav.querySelectorAll('[data-tt-group] [data-key]')];
    const state = Object.fromEntries(Object.entries(names).map(([g,p]) => [g,new URL(location.href).searchParams.get(p)||'']));
    const giftCollection = nav.dataset.baseCollection === 'gift-card';
    const find = (g,key) => buttons.find(b => b.closest('[data-tt-group]').dataset.ttGroup === g && b.dataset.key === key);
    if (!state.category) {
      const initial = buttons.find(b => (b.dataset.collection || b.dataset.categoryCollection) === nav.dataset.currentCollection);
      if (initial) state.category = initial.dataset.key;
    }
    if (!state.format) {
      const initialFormat = buttons.find(b => b.dataset.formatCollection === nav.dataset.currentCollection);
      if (initialFormat) state.format = initialFormat.dataset.key;
    }
    buttons.forEach(b => {
      const g = b.closest('[data-tt-group]').dataset.ttGroup;
      if (!state[g] && currentTags.has(b.dataset.categoryTag || b.dataset.tag)) state[g] = b.dataset.key;
    });
    // A feature collection must keep its constraint when another filter is selected.
    if (nav.dataset.currentCollection === 'caffeine-free' && !state.caffeine) state.caffeine = 'free';
    const independentCategories = new Set(['tea-pots','tea-filters','fairness-cups-gong-dao-bei','others']);
    const independentCategory = button => independentCategories.has(button?.dataset.categoryCollection);
    const restricted = nav.dataset.baseCollection === 'teaware';
    buttons.forEach(b => {
      const g = b.closest('[data-tt-group]').dataset.ttGroup;
      const tag = b.dataset.categoryTag || b.dataset.tag;
      const unavailable = independentCategory(b) ? Number(b.dataset.collectionCount) === 0 : tag && !available.has(tag);
      if ((restricted || g === 'caffeine') && unavailable) {
        b.disabled = true;
        b.classList.add('tt-filter-unavailable');
        if (g === 'caffeine') b.hidden = true;
      }
    });
    const caffeine = nav.querySelector('[data-tt-group="caffeine"]');
    if (caffeine && ![...caffeine.querySelectorAll('button')].some(b => !b.disabled)) caffeine.hidden = true;
    let invalid = false;
    if (state.caffeine && find('caffeine',state.caffeine)?.disabled) {
      notice.hidden = false;
    }
    Object.entries(state).forEach(([g,key]) => {
      const selected = find(g,key);
      const tag = selected?.dataset.categoryTag || selected?.dataset.tag;
      if (giftCollection && g === 'purpose') {
        if (key && !selected) invalid = true;
      } else if (key && selected && (selected.disabled || (!independentCategory(selected) && tag && !available.has(tag)))) invalid = true;
    });
    const routeFor = next => {
      const category = find('category',next.category);
      const format = find('format',next.format);
      const independent = independentCategory(category);
      const caffeineCollection = nav.dataset.baseCollection === 'all-tea' && !next.category && next.caffeine === 'free';
      const base = format?.dataset.formatCollection || (independent ? category.dataset.categoryCollection : category?.dataset.collection) || (caffeineCollection ? 'caffeine-free' : nav.dataset.baseCollection);
      const tags = Object.entries(next)
        .filter(([g]) => (!giftCollection || g !== 'purpose') && (!independent || g !== 'category') && (!caffeineCollection || g !== 'caffeine'))
        .map(([g,key]) => find(g,key)).filter(Boolean)
        .map(b => b.dataset.categoryTag || b.dataset.tag).filter(Boolean);
      return {base,tags:[...new Set(tags)],independent,caffeineCollection};
    };
    const go = (next, replace = false) => {
      const u = new URL(location.href);
      const route = routeFor(next);
      Object.entries(names).forEach(([g,p]) => {
        u.searchParams.delete(p);
        if (next[g] && !(route.independent && g === 'category') && !(route.caffeineCollection && g === 'caffeine')) u.searchParams.set(p,next[g]);
      });
      ['filter.p.product_type','filter.p.tag','page'].forEach(p => u.searchParams.delete(p));
      const tags = route.tags.filter(tag => available.has(tag));
      u.pathname = (window.Shopify?.routes?.root || '/') + 'collections/' + route.base + (tags.length ? '/' + tags.join('+') : '');
      if (u.href === location.href) return false;
      replace ? location.replace(u) : location.assign(u);
      return true;
    };
    const expectedRoute = routeFor(state);
    const expectedTags = expectedRoute.tags;
    const expectedFormatCollection = find('format',state.format)?.dataset.formatCollection;
    if (!invalid && (expectedRoute.independent || expectedRoute.caffeineCollection) && (expectedRoute.base !== nav.dataset.currentCollection || currentTags.size !== expectedTags.length) && go(state,true)) return;
    if (!invalid && expectedFormatCollection && expectedFormatCollection !== nav.dataset.currentCollection && go(state,true)) return;
    if (!invalid && expectedTags.some(tag => !currentTags.has(tag)) && go(state,true)) return;
    buttons.forEach(b => {
      const g = b.closest('[data-tt-group]').dataset.ttGroup;
      const active = state[g] === b.dataset.key;
      b.classList.toggle('is-active',active);
      b.setAttribute('aria-pressed',String(active));
      b.addEventListener('click',() => go({...state,[g]:active ? '' : b.dataset.key}));
    });
    const clear = () => {
      const u = new URL(location.href);
      [...Object.values(names),'filter.p.product_type','filter.p.tag','filter.v.price.gte','filter.v.price.lte','filter.v.availability','page'].forEach(p => u.searchParams.delete(p));
      u.pathname = (window.Shopify?.routes?.root || '/') + 'collections/' + nav.dataset.baseCollection;
      location.assign(u);
    };
    const clearButton = nav.querySelector('[data-tt-clear]');
    clearButton.classList.toggle('is-visible',Object.values(state).some(Boolean));
    clearButton.addEventListener('click',clear);
    summary.replaceChildren();
    Object.entries(state).forEach(([g,key]) => {
      const original = find(g,key);
      if (!original || !key) return;
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'tt-active-chip';
      chip.textContent = original.textContent.trim() + ' ×';
      chip.addEventListener('click',() => go({...state,[g]:''}));
      summary.append(chip);
    });
    if (summary.childElementCount) {
      const reset = document.createElement('button');
      reset.type = 'button';reset.className = 'tt-active-reset';reset.textContent = clearButton.textContent;reset.addEventListener('click',clear);summary.append(reset);
    }
    if (invalid) {
      section.querySelector('#ProductGridContainer').hidden = true;
      section.querySelector('[data-tt-invalid-filter]').hidden = false;
      section.querySelectorAll('#ProductCount,#ProductCountDesktop,[data-tt-result-count]').forEach(e => {e.textContent = '0';});
    } else applyGiftPurpose(nav);
  };
  const initAll = () => document.querySelectorAll('.tt-filters').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load',initAll);
  new MutationObserver(initAll).observe(document.querySelector('main'),{childList:true,subtree:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["teetao-workshops-page"] && !Shopify.designMode) return;
  try {
    (()=>{document.querySelectorAll('[data-tt-events]').forEach(root=>{const search=root.querySelector('[data-event-search]'),category=root.querySelector('[data-event-category]'),location=root.querySelector('[data-event-location]'),status=root.querySelector('[data-event-status]'),cards=[...root.querySelectorAll('[data-event-card]')],empty=root.querySelector('[data-event-empty]'),now=new Date();const monthLabel=root.querySelector(".tt-calendar__month"),days=root.querySelector(".tt-calendar__days"),locale=document.documentElement.lang||"en",year=now.getFullYear(),month=now.getMonth();if(monthLabel&&days){const label=new Intl.DateTimeFormat(locale,{month:"long",year:"numeric"}).format(now);monthLabel.textContent=label;monthLabel.parentElement.setAttribute("aria-label",label);days.replaceChildren();const offset=(new Date(year,month,1).getDay()+6)%7,total=new Date(year,month+1,0).getDate();for(let i=0;i<offset+total;i++){const cell=document.createElement("span");if(i>=offset){const day=i-offset+1;cell.textContent=String(day);if(cards.some(card=>{const start=new Date(card.dataset.start);return start.getFullYear()===year&&start.getMonth()===month&&start.getDate()===day}))cell.className="has-event";}days.append(cell);}}cards.forEach(card=>{const start=new Date(card.dataset.start),end=new Date(card.dataset.end),state=now<start?'upcoming':now<=end?'ongoing':'ended';card.dataset.status=state;const action=card.querySelector('[data-event-action]');if(action&&state==='ended'){action.textContent=root.dataset.endedLabel;action.classList.add('is-ended');action.removeAttribute('href');action.setAttribute('aria-disabled','true')}});const apply=()=>{const q=search.value.trim().toLowerCase(),c=category.value,l=location.value,s=status.value;let shown=0;cards.forEach(card=>{const visible=(!q||card.textContent.toLowerCase().includes(q))&&(!c||card.dataset.category===c)&&(!l||card.dataset.location===l)&&(!s||card.dataset.status===s);card.hidden=!visible;if(visible)shown++});empty.hidden=shown!==0;root.querySelectorAll('[data-sidebar-category]').forEach(button=>button.classList.toggle('is-active',button.dataset.sidebarCategory===c))};search.addEventListener('input',apply);category.addEventListener('change',apply);location.addEventListener('change',apply);status.addEventListener('change',apply);root.querySelector('[data-event-reset]').addEventListener('click',()=>{search.value='';category.value='';location.value='';status.value='';apply()});root.querySelectorAll('[data-sidebar-category]').forEach(button=>button.addEventListener('click',()=>{category.value=button.dataset.sidebarCategory;apply()}));apply()})})();
  } catch(e) { console.error(e); }
})();

})();
